/** @jsx h */
/** @jsxFrag Fragment */
import { h } from "preact";
import { ParamDict, ParamDictToProps } from "@utils/params";
import { A } from "@utils/utils";
import { HSLACss } from "@utils/color";
import { Block, PageBase } from "@uiw/utils";

export const DkParams = {
  "line/width": { type: "int", value: 25, min: 1, max: 100 },
  "line/heigth": { type: "int", value: 550, min: 1, max: 1000 },
  "line/n": { type: "int", value: 9, min: 1, max: 50 },
  "color/bg": { type: "hsla", value: { h: 0, s: 100, l: 100, a: 1 } },
  "color/l1": { type: "hsla", value: { h: 0, s: 76, l: 47, a: 0.8 } },
  "color/l2": { type: "hsla", value: { h: 122, s: 34, l: 38, a: 0.8 } },
  "color/l3": { type: "hsla", value: { h: 230, s: 40, l: 70, a: 0.8 } },
} as const satisfies ParamDict;

export type DkParams = typeof DkParams;
export const DkPropsDef = ParamDictToProps(DkParams);
export type DkOpts = typeof DkPropsDef;

export interface DkElemProps {
  opts?: Partial<DkOpts>;
}
export function DkElem(props: DkElemProps) {
  const opts = { ...DkPropsDef, ...props.opts } as DkOpts;

  const lineBase = {
    position: "absolute",
    width: opts["line/width"],
    height: opts["line/heigth"],
    "mix-blend-mode": "darken",
  };

  const deg = 360 / opts["line/n"];

  const colors = [HSLACss(opts[`color/l1`]), HSLACss(opts[`color/l2`]), HSLACss(opts[`color/l3`])];

  const lines = A(opts["line/n"]).map((_, i) => {
    return (
      <div
        class="line"
        style={{
          ...lineBase,
          transform: `rotate(${deg * i}deg)`,
          "background-color": colors[i % 3],
        }}
      />
    );
  });

  return (
    <div
      style={{
        width: opts["line/heigth"] + opts["line/heigth"] / 25,
        height: opts["line/heigth"] + opts["line/heigth"] / 25,
        position: "relative",
        backgroundColor: HSLACss(opts["color/bg"]),
      }}
    >
      <div style={{ marginLeft: opts["line/heigth"] / 2, paddingTop: opts["line/heigth"] / 50 }}>
        {lines}
      </div>
    </div>
  );
}

export interface CardDkProps {}
export function CardDk(props: CardDkProps) {
  const opts = DkPropsDef;

  return (
    <PageBase style={{ backgroundColor: HSLACss(opts["color/bg"]) }}>
      <Block row={[1, 54]} col={[1, 42]}>
        <DkElem />
      </Block>
    </PageBase>
  );
}
